import {
  useQuery,
} from '@tanstack/react-query'

import { resourcefulRequest } from './requests'

export function useRoleSelectionQuery({
  initialData,
  queryKey
}) {

  const roleRequests = resourcefulRequest(
    'role-selection'
  )

  const roleQuery = useQuery({
    queryFn: roleRequests.index,
    queryKey,
    initialData
  })

  const isFetching = roleQuery.isFetching

  const isAnyLoading = roleQuery.isFetching

  return {
    data: roleQuery.data,
    actions: {
      update: roleRequests.update
    },
    status: roleQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
